module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9jc81"))).then(() => parcelRequire('hEqeo'));